import { getProductPageUrlSync, getProductUrlSync } from '@msdyn365-commerce-modules/retail-actions';
import { CategoryHierarchy, FullProduct } from '@msdyn365-commerce/commerce-entities';
import { ICoreContext, IRequestContext } from '@msdyn365-commerce/core';
import { AttributeValue, ProductPrice, ProductRating, ProductSearchResult } from '@msdyn365-commerce/retail-proxy';
export interface IProductPlacementDataItem {
    description?: string;
    heading?: string;
    price?: IPrice;
    rating?: IRating;
    image?: string;
    productUrl?: string;
    recordId?: number;
    attributes?: AttributeValue[];
}
export interface IPrice {
     locale: string;
    currencyCode: string;
    freePriceText: string;
    currentPrice?: IPriceRange;
    originalPrice?: IPriceRange;
    rangeFormatText?: string;
    savingsText?: string;
    originalPriceText: string;
    currentPriceText: string;
}

export interface IRating {
    averageRating?: number;
    totalRatings?: number;
    ariaLabel?: string;
}

export interface IPriceRange {
    startingValue: number;
    endingValue?: number;
}

export function mapProductSearchResult(
    products: ProductSearchResult[],
    freePriceText: string,
    originalPriceText: string,
    currentPriceText: string,
    ratingAriaLabel: string,
    context: ICoreContext,
    CurrencyCode: string,
    category?: CategoryHierarchy
): IProductPlacementDataItem[] {
    if (products && products.length > 0) {
    const productItems: IProductPlacementDataItem[] = [];
    products.map(product => {
        if (product && product !== undefined && product.RecordId !== undefined) {
            const productUrl = getProductPageUrlSync(product.Name || '', product.RecordId, context && context.actionContext, category);
            const item = {
                heading: product.Name,
                description: product.Description,
                price: mapProductSearchResultPrice(context.request, freePriceText, CurrencyCode, originalPriceText, currentPriceText, product.BasePrice, product.Price),
                rating: mapProductSearchResultRating(ratingAriaLabel, product.TotalRatings, product.AverageRating),
                image: product.PrimaryImageUrl,
                productUrl: productUrl,
                recordId: product.RecordId
            };
            productItems.push(item);
        }
    });
    return productItems;
    }
    return [];
}

function mapProductSearchResultPrice(
    requestContext: IRequestContext,
    freePriceText: string,
    currencyCode: string,
    originalPriceText: string,
    currentPriceText: string,
    productBasePrice?: number,
    productPrice?: number,
): IPrice | undefined {
    if (productPrice !== undefined && requestContext) {
        return {
            locale: requestContext.locale,
            currencyCode: currencyCode,
            freePriceText: freePriceText,
            originalPriceText: originalPriceText,
            currentPriceText: currentPriceText,
            currentPrice: _mapNumberToIPriceRange(productPrice),
            originalPrice: _mapNumberToIPriceRange(productBasePrice)
        };
    }
    return undefined;
}

export function mapProductCollection(
    products: FullProduct[],
    freePriceText: string,
    ratingAriaLabel: string,
    originalPriceText: string,
    currentPriceText: string,
    context: ICoreContext,
    category?: CategoryHierarchy
): IProductPlacementDataItem[] {
    if(!products || products.length === 0) {
        return [];
    }

    const productItems: IProductPlacementDataItem[] = [];
    products.map(product => {
        if(product && product.ProductDetails) {
        const productUrl = getProductUrlSync(product.ProductDetails, context && context.actionContext, category);
        const item = {
            heading: product.ProductDetails.Name,
            description: product.ProductDetails.Description,
            price: mapProductPrice(product.ProductPrice, context.request, freePriceText, originalPriceText, currentPriceText),
            rating: mapProductRating(product.ProductRating, ratingAriaLabel),
            image: product.ProductDetails.PrimaryImageUrl,
            productUrl: productUrl,
            recordId: product.ProductDetails.RecordId,
            // @ts-ignore
            attributes: product.ProductAttributes
        };
        productItems.push(item);
    }
    });

    return productItems;
}

function mapProductPrice(
    productPrice: ProductPrice | undefined,
    requestContext: IRequestContext,
    freePriceText: string,
    originalPriceText: string,
    currentPriceText: string,
): IPrice | undefined {
    if (productPrice && requestContext) {
        return {
            locale: requestContext.locale,
            currencyCode: productPrice.CurrencyCode ? productPrice.CurrencyCode : '',
            freePriceText: freePriceText,
            originalPriceText: originalPriceText,
            currentPriceText: currentPriceText,
            currentPrice: _mapNumberToIPriceRange(productPrice.CustomerContextualPrice),
            originalPrice: _mapNumberToIPriceRange(
                Math.max(productPrice.BasePrice || 0, productPrice.TradeAgreementPrice || 0, productPrice.AdjustedPrice || 0)
            )
        };
    }
    return undefined;
}

function mapProductSearchResultRating(
    ariaLabel: string,
    productTotalRating?: number,
    productAverageRating?: number
): IRating | undefined {
    if (productTotalRating && productAverageRating) {
        return {
            averageRating: productAverageRating,
            totalRatings: productTotalRating,
            ariaLabel: ariaLabel
        };
    }
    return undefined;
}

function mapProductRating(
    productRating: ProductRating | undefined,
    ariaLabel: string
): IRating | undefined {
    if (productRating) {
        return {
            averageRating: productRating.AverageRating || 0,
            totalRatings: productRating.TotalRatings || 0,
            ariaLabel: ariaLabel
        };
    }
    return undefined;
}

function _mapNumberToIPriceRange(price: number | undefined): IPriceRange | undefined {
    if (price !== undefined) {
        return {
            startingValue: price
        };
    }
    return undefined;
}
